import { render, staticRenderFns } from "./verReclamoLeechero.vue?vue&type=template&id=92a760c0&scoped=true"
import script from "./verReclamoLeechero.vue?vue&type=script&lang=js"
export * from "./verReclamoLeechero.vue?vue&type=script&lang=js"
import style0 from "./verReclamoLeechero.vue?vue&type=style&index=0&id=92a760c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a760c0",
  null
  
)

export default component.exports